export interface MemberSocialLinks {
  facebook_url?: string;
  instagram_url?: string;
  linkedin_url?: string;
  twitter_url?: string;
  website_url?: string;
}

export const hasSocialLinks = (member: MemberSocialLinks) =>
  !!member.website_url ||
  !!member.facebook_url ||
  !!member.twitter_url ||
  !!member.linkedin_url ||
  !!member.instagram_url;

/**
 * Profile fields is required to know the pages where the API is being used
 * We add the param for this.
 */
export const PROFILE_PAGES = {
  SIGNUP: "signup",
  EDIT_PROFILE: "edit_profile",
  PROFILE_VIEW: "profile_view",
} as const;
